import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import { useState } from "react";
import { GeoJSON, WKT } from "ol/format";
import Feature from "ol/Feature";
import {
  getLayerIdByName,
  getProjectionCode,
  searchLayerRequest,
  addLayer,
  formatGEOJSONLayer,
  key,
  fetch,
  getGeometryTypeFromLayer,
  trans,
} from "../../lib/utils";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";
import md5 from "md5";
import BootstrapTable from "react-bootstrap-table-next";
import FeaturesTable from "../controls/featuresTable";
import SelectFeaturesFromUploadFile from "../controls/selectFeaturesFromUploadFile";
import {
  FeatureToGeoJSON,
  GeoJSONToWKT,
  WKTtoGeoJSON,
  filterGeoJSONFromAttribute,
  formatSearchResultsFromServiceResponse,
  showFeature,
} from "../../lib/featureUtils";
import SelectLayerDropdown from "../controls/selectLayerDropdown";
import SelectAttributesDropdown from "../controls/selectAttributesDropdrown";
import { editInteraction, getInteraction, removeInteraction } from "./editUtil";
import { getLayerById, getMapProjection } from "../map/mapUtils";
import {
  Draw,
  Modify,
  Select,
  Snap,
  defaults as defaultInteractions,
} from "ol/interaction.js";
import Editors from "../editors/editors";
import {
  Geometry,
  GeometryCollection,
  LineString,
  MultiPolygon,
  MultiLineString,
  MultiPoint,
  Polygon,
  Point,
} from "ol/geom";
import { intersect, polygon, featureCollection, union } from "@turf/turf";
import { cloneDeep } from "lodash";

function EditPanel() {
  const editableLayers = useSelector(
    (state) => store.getState().edit.editableLayers
  );
  const [selectedProjection, setSelectedProjection] = useState("EPSG:4326");

  const editConfig = useSelector((state) => store.getState().edit.editConfig);

  const favorites = useSelector(
    (state) => store.getState().results.favoriteResults
  );

  const selectedLayer = useSelector((state) => store.getState().edit.editLayer);

  const selectedFeature = useSelector(
    (state) => store.getState().edit.selectedFeature
  );

  const highlightedFeatures = useSelector(
    (state) => store.getState().edit.highlightedFeatures
  );

  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);

  const [newLayerName, setNewLayerName] = useState(null);

  const [newLayerColor, setNewLayerColor] = useState({ hex: "" });

  const [projection, setProjection] = useState("EPSG:4326");

  const [geometryType, setGeometryType] = useState("polygon");

  const [geometryMulti, setGeometryMulti] = useState(true);

  const [newLayerAttributes, setNewLayerAttributes] = useState([]);

  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const styles = reactCSS({
    default: {
      swatch: {
        padding: "5px",
        background: "#fff",
        borderRadius: "1px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
        display: "inline-block",
        cursor: "pointer",
        width: "100%",
      },
      popover: {
        position: "relative",
        // zIndex: "2",
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
    },
  });

  function editDrawSnap() {
    Object.keys(editableLayers).forEach((el) => {
      if (layers[el].editCanTrace) {
        const editSnap = new Snap({
          source: getLayerById(selectedLayer).getSource(),
          edge: layers[selectedLayer].editCanSnapVertex ? true : false,
          vertex: layers[selectedLayer].editCanSnapEdge ? true : false,
        });

        editSnap.interactionId = "editSnap-".concat(el);
        window["map"].addInteraction(editSnap);
      }
    });
  }

  function editDrawInteraction(type, append) {
    store.dispatch({ type: "edit/highlightedFeatures", payload: [] });

    if (append) {
      store.dispatch({
        type: "edit/config/update",
        payload: {
          property: "selected",
          value: [selectedFeature],
        },
      });
    }

    iniateInteractions();

    if (type !== "None") {
      window["editDraw"] = new Draw({
        source: getLayerById(selectedLayer).getSource(),
        type: type,
      });
      window["editDraw"].on("drawend", function (e) {
        if (append) {
          mergeFeatures([e.feature]);
        }

        window["map"].removeInteraction(window["editDraw"]);
      });
      window["map"].addInteraction(window["editDraw"]);
      editDrawSnap();
    }
  }

  function iniateInteractions() {
    store.dispatch({ type: "edit/initiate" });
    window["map"].removeInteraction(window["editSelect"]);
    window["map"].removeInteraction(window["editModify"]);
    window["map"].removeInteraction(window["editDraw"]);
    window["map"]?.getInteractions().forEach((el) => {
      if (el?.interactionId?.startsWith("editSnap-")) {
        window["map"].removeInteraction(el);
      }
    });
  }

  function onSelect(event) {
    let selectedFeatures = [];
    let deselectedFeatures = [];

    if (event.selected.length > 0) {
      let feature = event.selected[0];

      selectedFeatures.push({
        _featureId: feature.getId(),
        feature: feature,
        _feature: FeatureToGeoJSON(feature),
        wkt: GeoJSONToWKT(
          FeatureToGeoJSON(feature),
          window["map"].getView().getProjection().getCode(),
          window["map"].getView().getProjection().getCode()
        ),
      });
    }

    if (event.deselected.length > 0) {
      deselectedFeatures = event.deselected.map((el) => {
        return el.getId();
      });
    }

    store.dispatch({
      type: "edit/selectFeature",
      payload: { selected: selectedFeatures, deselected: deselectedFeatures },
    });
  }

  function editModifyInteraction() {
    iniateInteractions();

    let features = window["editSelect"].getFeatures();

    window["editModify"] = new Modify({
      features: features,
    });

    window["map"].addInteraction(window["editModify"]);
  }

  function editSelectInteraction() {
    iniateInteractions();

    window["editSelect"] = new Select({
      source: getLayerById(selectedLayer).getSource(),
    });

    window["editSelect"].un("select", onSelect);

    window["editSelect"].on("select", onSelect);

    window["map"].addInteraction(window["editSelect"]);
  }

  const fetchSpatialResults = (layerId) => {
    store.dispatch({
      type: "edit/config/update",
      payload: {
        property: "searchData",
        value: "pending",
      },
    });

    const layer = layers[layerId];

    const source = sources[layer.source.id];

    if (source.type === "GEOJSON") {
      let data = filterGeoJSONFromAttribute(
        JSON.parse(source.url),
        editConfig["attribute"],
        editConfig["attributeOperator"] ? editConfig["attributeOperator"] : "=",
        editConfig["attributeValue"]
      );

      store.dispatch({
        type: "edit/config/update",
        payload: {
          property: "searchData",
          value: data,
        },
      });
    } else {
      let cql = editConfig["attribute"].concat(
        " ",
        editConfig["attributeOperator"] ? editConfig["attributeOperator"] : "=",
        " ",
        editConfig["attributeValue"]
      );

      fetch(
        window["appConfig"]()["api"](),
        "POST",
        {},
        [searchLayerRequest(layer, source, cql, null)],
        (resp) => {
          let data = formatSearchResultsFromServiceResponse(resp);

          store.dispatch({
            type: "edit/config/update",
            payload: {
              property: "searchData",
              value: data,
            },
          });
        }
      );
    }
  };

  const updateSelectedComponents = (selected) => {
    let selectedFiltered = editConfig["selectedComponents"]
      ? [...editConfig["selectedComponents"]]
      : [];

    if (Array.isArray(selected)) {
      selectedFiltered = [...selected];
    } else {
      let selectedExistIndex = null;

      selectedFiltered?.forEach((el, idx) => {
        if (selected.componentId === el.componentId) {
          selectedExistIndex = idx;
        }
      });

      if (selectedExistIndex !== null) {
        selectedFiltered.splice(selectedExistIndex, 1);
      } else {
        selectedFiltered.push(selected);
      }
    }

    store.dispatch({
      type: "edit/config/update",
      payload: {
        property: "selectedComponents",
        value: selectedFiltered,
      },
    });
  };

  const updateSelectedFeatures = (selected) => {
    let selectedFiltered = editConfig["selected"]
      ? [...editConfig["selected"]]
      : [];

    if (Array.isArray(selected)) {
      selectedFiltered = [...selected];
    } else {
      let selectedExistIndex = null;

      selectedFiltered?.forEach((el, idx) => {
        if (selected._featureId === el._featureId) {
          selectedExistIndex = idx;
        }
      });

      if (selectedExistIndex !== null) {
        selectedFiltered.splice(selectedExistIndex, 1);
      } else {
        selectedFiltered.push(selected);
      }
    }

    store.dispatch({
      type: "edit/config/update",
      payload: {
        property: "selected",
        value: selectedFiltered,
      },
    });
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (data, isSelected) => {
      updateSelectedFeatures(data);
    },
    selected: editConfig["selected"]
      ? editConfig["selected"].map((el) => {
          return el._featureId;
        })
      : [],
    onSelectAll: (isSelected, data, e) => {
      updateSelectedFeatures(data);
    },
  };

  const selectComponent = {
    mode: "checkbox",
    onSelect: (data, isSelected) => {
      updateSelectedComponents(data);
    },
    selected: editConfig["selectedComponents"]
      ? editConfig["selectedComponents"].map((el) => {
          return el.componentId;
        })
      : [],
    onSelectAll: (isSelected, data, e) => {
      updateSelectedComponents(data);
    },
  };

  function GeoJSONToWKT(feature, toProjection) {
    const json = new GeoJSON({
      dataProjection: feature.projection ? feature.projection : "EPSG:4326",
      featureProjection: toProjection,
    }).readFeature(feature);

    const wkt = new WKT().writeFeature(json);
    return wkt;
  }

  useEffect(() => {
    if (selectedLayer && selectedLayer !== "new") {
      setGeometryType(
        getGeometryTypeFromLayer(layers[selectedLayer]?.geometryType)
      );
      onLayerFeature(selectedLayer);
    }
  }, [selectedLayer]);

  function getFeatureComponents(feature) {
    let components = [];

    feature
      .getGeometry()
      .getCoordinates()
      .forEach((el, idx) => {
        components.push({
          componentId: "component-".concat(idx + 1),
          geometry: el,
          componentIndex: idx,
        });
      });

    return (
      <div className="mt-2">
        <BootstrapTable
          key={key()}
          keyField="componentId"
          data={components}
          columns={[
            {
              dataField: "_zoomToFeature",
              text: "",
              headerStyle: (colum, colIndex) => {
                return { width: "30px", textAlign: "center" };
              },
              formatter: function (cell, row) {
                return (
                  <i
                    className="fas fa-compress  m-auto"
                    role="button"
                    onClick={(e) => {
                      let geometry = null;

                      switch (
                        getGeometryTypeFromLayer(
                          layers[selectedLayer].geometryType
                        )
                      ) {
                        case "polygon":
                          geometry = new Polygon(row.geometry);
                          break;

                        case "line":
                          geometry = new LineString(row.geometry);
                          break;

                        case "point":
                          geometry = new Point(row.geometry);
                          break;
                      }

                      let _f = new Feature({
                        geometry: geometry,
                      });

                      _f.projection = getMapProjection();

                      let geoJSONFeature = FeatureToGeoJSON(_f);

                      geoJSONFeature.projection = getMapProjection();

                      showFeature(geoJSONFeature, null, 15);
                    }}
                  ></i>
                );
              },
            },
            {
              dataField: "_deleteComponent",
              text: "",
              headerStyle: (colum, colIndex) => {
                return { width: "30px", textAlign: "center" };
              },
              formatter: function (cell, row) {
                return (
                  <i
                    className="fas fa-trash-alt  m-auto"
                    role="button"
                    onClick={(e) => {
                      let newComponents = [];

                      switch (
                        getGeometryTypeFromLayer(
                          layers[selectedLayer].geometryType
                        )
                      ) {
                        case "polygon":
                          feature
                            .getGeometry()
                            .getPolygons()
                            .forEach((el, idx) => {
                              if (row.componentIndex !== idx) {
                                newComponents.push(el);
                              }
                            });

                          feature.setGeometry(new MultiPolygon(newComponents));

                          break;

                        case "line":
                          feature
                            .getGeometry()
                            .getLineStrings()
                            .forEach((el, idx) => {
                              if (row.componentIndex !== idx) {
                                newComponents.push(el);
                              }
                            });

                          feature.setGeometry(
                            new MultiLineString(newComponents)
                          );
                          break;

                        case "point":
                          feature
                            .getGeometry()
                            .getPoints()
                            .forEach((el, idx) => {
                              if (row.componentIndex !== idx) {
                                newComponents.push(el);
                              }
                            });

                          feature.setGeometry(new MultiPoint(newComponents));
                          break;
                      }

                      store.dispatch({
                        type: "edit/update/feature/components",
                      });
                    }}
                  ></i>
                );
              },
            },
            {
              dataField: "componentId",
              text: "Components",
            },
            {
              dataField: "componentIndex",
              text: "",
            },
          ]}
          wrapperClasses="bg-white"
          striped
          hover
          selectRow={selectComponent}
        ></BootstrapTable>
      </div>
    );
  }

  function selectedContent() {
    let attributes = layers[selectedLayer].attributes;

    if (selectedFeature) {
      let featureProperties = selectedFeature._feature.properties;

      setTimeout(window["recaclulatePerfectScrollbarHeight"], 500);

      return (
        <div className="mt-3">
          <small className="color-blue-get">
            {trans("Feature id")}: {selectedFeature.feature.getId()}
          </small>
          <ul className="nav nav-tabs navbar-expand small">
            <li className="nav-item " role="button">
              <span
                className="nav-link color-strong-grey nav-ellipsis active"
                data-bs-toggle="tab"
                data-bs-target={"#edit-feature-attributes"}
              >
                <span className="color-black">{trans("Attributes")}</span>
              </span>
            </li>
            <li className="nav-item " role="button">
              <span
                className="nav-link color-strong-grey nav-ellipsis "
                data-bs-toggle="tab"
                data-bs-target={"#edit-feature-geometry"}
              >
                <span className="color-black">{trans("Geometry")}</span>
              </span>
            </li>
            <li className="nav-item " role="button">
              <span
                className="nav-link color-strong-grey nav-ellipsis "
                data-bs-toggle="tab"
                data-bs-target={"#edit-feature-geometry-components"}
              >
                <span className="color-black">
                  {trans("Geometry components")} (
                  {selectedFeature?.feature?.getGeometry()?.endss_?.length})
                </span>
              </span>
            </li>
          </ul>
          <div className="tab-content ">
            <div
              className="tab-pane fade  show active"
              role="tabpanel"
              id="edit-feature-attributes"
            >
              <PerfectScrollbar className="scrollbar-recaclulate">
                <div className="mt-2 me-3">
                  {attributes.map((el) => {
                    return (
                      <div className="d-flex mt-2 w-100">
                        <div className="d-block me-2  small">{el.title}</div>
                        <div className="w-100">
                          {Editors(
                            featureProperties?.[el.name]
                              ? featureProperties[el.name]
                              : "",
                            el.type,
                            true,
                            {
                              onChange: (e) => {
                                store.dispatch({
                                  type: "edit/update/feature/property",
                                  payload: {
                                    property: el.name,
                                    value: e.target.value,
                                  },
                                });
                              },
                              className: "form-control form-control-sm w-100",
                            }
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <div className="mt-2 text-end">
                    <button
                      className="btn btn-sm btn-secondary text-white"
                      onClick={saveFeature}
                    >
                      {trans("Save feature")}
                    </button>
                  </div>
                </div>
              </PerfectScrollbar>
            </div>
            <div
              className="tab-pane fade "
              role="tabpanel"
              id="edit-feature-geometry"
            >
              <div className="mt-3">
                <label className="color-get-blue strong ">
                  {trans("Select projection system")}
                </label>
                <select
                  className="form-select form-select-sm "
                  value={selectedProjection}
                  onChange={(e) => {
                    setSelectedProjection(e.target.value);
                  }}
                >
                  {window["appConfig"]()["projectionSystems"].map((opt) => {
                    return <option value={opt.code}>{opt.title}</option>;
                  })}
                </select>
                <PerfectScrollbar className="scrollbar-recaclulate">
                  <div className="p-2 border mt-3 bg-light small">
                    {GeoJSONToWKT(selectedFeature._feature, selectedProjection)}
                  </div>
                </PerfectScrollbar>
              </div>
            </div>
            <div
              className="tab-pane fade "
              role="tabpanel"
              id="edit-feature-geometry-components"
            >
              <div className="mt-3">
                {getFeatureComponents(selectedFeature.feature)}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return highlightedFeatures.length > 0 ? (
        <div className="mt-2">
          <BootstrapTable
            key={key()}
            keyField="_featureId"
            data={highlightedFeatures}
            columns={[
              {
                dataField: "_featureId",
                text: "",
                hidden: true,
              },
              {
                dataField: "_feature",
                text: "",
                hidden: true,
              },
              {
                dataField: "deleteFeature",
                headerStyle: (colum, colIndex) => {
                  return { width: "30px", textAlign: "center" };
                },
                formatter: function (cell, row) {
                  return (
                    <i
                      className="fas fa-trash-alt  m-auto"
                      role="button"
                      onClick={(e) => {
                        deleteFeature([row.feature]);

                        let selectedFiltered = [];

                        highlightedFeatures?.forEach((el) => {
                          if (row._featureId !== el._featureId) {
                            selectedFiltered.push(el);
                          }
                        });

                        store.dispatch({
                          type: "edit/highlightedFeatures",
                          payload: selectedFiltered,
                        });
                      }}
                    ></i>
                  );
                },
              },
              {
                dataField: "_zoomToFeature",
                headerStyle: (colum, colIndex) => {
                  return { width: "30px", textAlign: "center" };
                },
                formatter: function (cell, row) {
                  return (
                    <i
                      className="fas fa-compress  m-auto"
                      role="button"
                      onClick={(e) => {
                        showFeature(row._feature);
                      }}
                    ></i>
                  );
                },
              },
              {
                dataField: "_featureId",
                text: "Feature id",
              },
            ]}
            wrapperClasses="bg-white"
            striped
            hover
            selectRow={selectRow}
          ></BootstrapTable>
        </div>
      ) : (
        ""
      );
    }
  }

  function deleteFeature(features) {
    features.forEach((feature) => {
      getLayerById(selectedLayer).getSource().removeFeature(feature);
    });
  }

  const splitFeatures = (feature) => {
    let newComponents = [];

    let selectedComponentsIndex = editConfig["selectedComponents"].map((el) => {
      return el.componentIndex;
    });

    switch (getGeometryTypeFromLayer(layers[selectedLayer].geometryType)) {
      case "polygon":
        feature
          .getGeometry()
          .getPolygons()
          .forEach((el, idx) => {
            if (selectedComponentsIndex.indexOf(idx) < 0) {
              newComponents.push(el);
            } else {
              getLayerById(selectedLayer)
                .getSource()
                .addFeature(
                  new Feature({
                    geometry: new MultiPolygon([
                      editConfig["selectedComponents"][idx].geometry,
                    ]),
                  })
                );
            }
          });

        feature.setGeometry(new MultiPolygon(newComponents));

        break;

      case "line":
        feature
          .getGeometry()
          .getLineStrings()
          .forEach((el, idx) => {
            if (selectedComponentsIndex.indexOf(idx) < 0) {
              newComponents.push(el);
            } else {
              getLayerById(selectedLayer)
                .getSource()
                .addFeature(
                  new Feature({
                    geometry: new MultiLineString([
                      editConfig["selectedComponents"][idx].geometry,
                    ]),
                  })
                );
            }
          });

        feature.setGeometry(new MultiLineString(newComponents));
        break;

      case "point":
        feature
          .getGeometry()
          .getPoints()
          .forEach((el, idx) => {
            if (selectedComponentsIndex.indexOf(idx) < 0) {
              newComponents.push(el);
            } else {
              getLayerById(selectedLayer)
                .getSource()
                .addFeature(
                  new Feature({
                    geometry: new MultiPoint([
                      editConfig["selectedComponents"][idx].geometry,
                    ]),
                  })
                );
            }
          });

        feature.setGeometry(new MultiPoint(newComponents));
        break;
    }

    store.dispatch({
      type: "edit/update/feature/components",
    });
  };

  const mergeFeatures = (features, defaultFeature) => {
    if (editConfig["selected"].length !== 1) {
      window["primaryModal"].setState({
        title: "Attention",
        show: true,
        body: (
          <p>
            {trans(
              "Please select only one feature that will copy the properties from"
            )}
          </p>
        ),
        footer: [
          <button
            className="btn btn-sm btn-link"
            onClick={(e) => {
              window["primaryModal"].setState({
                show: false,
              });
            }}
          >
            {trans("Cancel")}
          </button>,
        ],
      });
    } else {
      // let geometries = [editConfig["selected"][0].feature.getGeometry()];

      features.forEach((el) => {
        //  geometries.push(cloneDeep(el.getGeometry()));

        switch (getGeometryTypeFromLayer(layers[selectedLayer].geometryType)) {
          case "polygon":
            editConfig["selected"][0].feature
              .getGeometry()
              .appendPolygon(el.getGeometry());
            break;

          case "line":
            editConfig["selected"][0].feature
              .getGeometry()
              .appendLineString(el.getGeometry());
            break;

          case "point":
            editConfig["selected"][0].feature
              .getGeometry()
              .appendPoint(el.getGeometry());
            break;
        }
      });

      // editConfig["selected"][0].feature.getGeometry();

      // let mergedFeature = new Feature({
      //   geometry: new GeometryCollection(geometries),
      // });

      // mergedFeature.setProperties({
      //   ...editConfig["selected"][0].feature.getProperties(),
      // });

      // mergedFeature.setId(editConfig["selected"][0].feature.getId());
      // console.log(mergedFeature);

      // editConfig["selected"][0].feature.setGeometry(
      //   new GeometryCollection(geometries)
      // );

      // getLayerById(selectedLayer).getSource().addFeature(mergedFeature);

      setTimeout(function () {
        features.forEach((el) => {
          getLayerById(selectedLayer).getSource().removeFeature(el);
        });
      }, 500);

      store.dispatch({ type: "edit/highlightedFeatures", payload: [] });
    }
  };

  const editSpatialContent = () => {
    console.log(geometryType);
    switch (editConfig.spatialType) {
      case "draw":
        return (
          <>
            <div className="mt-2">
              {geometryType === "polygon" ? (
                <button
                  type="button"
                  className={"btn btn-sm small border m-1 "}
                  data-bs-toggle="button"
                  onClick={(e) => {
                    editDrawInteraction("Polygon");
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("New polygon feature")}
                </button>
              ) : (
                ""
              )}
              {geometryType === "line" ? (
                <button
                  type="button"
                  className={"btn btn-sm small border me-1 "}
                  data-bs-toggle="button"
                  onClick={(e) => {
                    editDrawInteraction("LineString");
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("New line feature")}
                </button>
              ) : (
                ""
              )}
              {geometryType === "point" ? (
                <button
                  type="button"
                  className={"btn btn-sm small border me-1 "}
                  data-bs-toggle="button"
                  onClick={(e) => {
                    editDrawInteraction("Point");
                  }}
                >
                  <i className="fas fa-map-marker-alt me-2"></i>
                  {trans("New point feature")}
                </button>
              ) : (
                ""
              )}
            </div>

            {/* {editConfig["selected"]?.length > 0 ? (
              <>
                <div className="mt-2">
                  <BootstrapTable
                    key={key()}
                    keyField="_featureId"
                    data={editConfig["selected"] ? editConfig["selected"] : []}
                    columns={[
                      {
                        dataField: "_featureId",
                        text: "",
                        hidden: true,
                      },
                      {
                        dataField: "_feature",
                        text: "",
                        hidden: true,
                      },
                      {
                        dataField: "deleteFeature",
                        headerStyle: (colum, colIndex) => {
                          return { width: "30px", textAlign: "center" };
                        },
                        formatter: function (cell, row) {
                          return (
                            <i
                              className="fas fa-trash-alt  m-auto"
                              role="button"
                              onClick={(e) => {
                                deleteFeature([row.feature]);
                                let newSelected = [];

                                editConfig["selected"]?.forEach((el) => {
                                  if (row._featureId !== el._featureId) {
                                    newSelected.push(el);
                                  }
                                });

                                store.dispatch({
                                  type: "edit/config/update",
                                  payload: {
                                    property: "selected",
                                    value: [...newSelected],
                                  },
                                });
                              }}
                            ></i>
                          );
                        },
                      },
                      {
                        dataField: "_zoomToFeature",
                        headerStyle: (colum, colIndex) => {
                          return { width: "30px", textAlign: "center" };
                        },
                        formatter: function (cell, row) {
                          return (
                            <i
                              className="fas fa-compress  m-auto"
                              role="button"
                              onClick={(e) => {
                                showFeature(row._feature);
                              }}
                            ></i>
                          );
                        },
                      },
                      {
                        dataField: "_featureId",
                        text: "Feature id",
                      },
                    ]}
                    wrapperClasses="bg-white"
                    striped
                    hover
                  ></BootstrapTable>
                </div>
              </>
            ) : (
              ""
            )} */}
          </>
        );
        break;

      case "modify":
        return (
          <>
            <div className="mt-2">
              <button
                type="button"
                className={"btn btn-sm small border me-1 "}
                data-bs-toggle="button"
                onClick={editSelectInteraction}
              >
                <i className="fas fa-draw-polygon me-2"></i>
                {trans("Select Feature")}
              </button>
              {geometryType === "polygon" && selectedFeature ? (
                <button
                  type="button"
                  className={"btn btn-sm small border m-1 "}
                  data-bs-toggle="button"
                  onClick={(e) => {
                    editDrawInteraction("Polygon", true);
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("Append polygon")}
                </button>
              ) : (
                ""
              )}
              {geometryType === "line" && selectedFeature ? (
                <button
                  type="button"
                  className={"btn btn-sm small border m-1 "}
                  data-bs-toggle="button"
                  onClick={(e) => {
                    editDrawInteraction("Line", true);
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("Append Line")}
                </button>
              ) : (
                ""
              )}
              {geometryType === "point" && selectedFeature ? (
                <button
                  type="button"
                  className={"btn btn-sm small border m-1 "}
                  data-bs-toggle="button"
                  onClick={(e) => {
                    editDrawInteraction("Point", true);
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("Append Point")}
                </button>
              ) : (
                ""
              )}
              {selectedFeature ? (
                <button
                  type="button"
                  className={"btn btn-sm small border me-1 "}
                  data-bs-toggle="button"
                  onClick={() => {
                    deleteFeature([selectedFeature.feature]);
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("Delete Feature")}
                </button>
              ) : (
                ""
              )}
              {highlightedFeatures.length > 1 && geometryMulti ? (
                <button
                  type="button"
                  className={"btn btn-sm small border me-1 "}
                  data-bs-toggle="button"
                  disabled={highlightedFeatures.length > 1 ? false : true}
                  onClick={() => {
                    mergeFeatures(
                      highlightedFeatures.map((el) => {
                        return el.feature;
                      })
                    );
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("Merge Features")}
                </button>
              ) : (
                ""
              )}
              {geometryMulti && selectedFeature ? (
                <button
                  type="button"
                  className={"btn btn-sm small border m-1 "}
                  data-bs-toggle="button"
                  disabled={
                    editConfig["selectedComponents"]?.length > 0 ? false : true
                  }
                  onClick={() => {
                    splitFeatures(selectedFeature.feature);
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("Split")}
                </button>
              ) : (
                ""
              )}
              {selectedFeature ? (
                <button
                  type="button"
                  className={"btn btn-sm small border m-1 "}
                  data-bs-toggle="button"
                  onClick={() => {
                    editModifyInteraction();
                  }}
                >
                  <i className="fas fa-draw-polygon me-2"></i>
                  {trans("Modify")}
                </button>
              ) : (
                ""
              )}
            </div>
          </>
        );
        break;

      case "layer":
        return (
          <>
            <div className="mt-2">
              <SelectLayerDropdown
                key={key()}
                layer={editConfig["layer"]}
                onChange={(e) => {
                  store.dispatch({
                    type: "edit/config/update",
                    payload: {
                      property: "layer",
                      value: e.target.value,
                    },
                  });
                }}
              ></SelectLayerDropdown>
            </div>
            <div className="mt-2">
              <SelectAttributesDropdown
                value={editConfig["attribute"]}
                attributes={layers[editConfig["layer"]]?.attributes}
                onChange={(e) => {
                  store.dispatch({
                    type: "edit/config/update",
                    payload: {
                      property: "attribute",
                      value: e.target.value,
                    },
                  });
                }}
              ></SelectAttributesDropdown>
            </div>
            <div className="mt-2 d-flex">
              <select
                style={{ width: "10rem" }}
                className="form-select form-select-sm form-control-sm form-control me-2"
                value={editConfig["attributeOperator"]}
                onChange={(e) => {
                  store.dispatch({
                    type: "edit/config/update",
                    payload: {
                      property: "attributeOperator",
                      value: e.target.value,
                    },
                  });
                }}
              >
                <option value="=">=</option>
                <option value="like">Like</option>
                <option value=">=">&gt;=</option>
                <option value=">">&gt;</option>
                <option value="<=">&lt;=</option>
                <option value="<">&lt;</option>
              </select>
              <input
                type="text"
                className="form-control form-control-sm "
                value={editConfig["attributeValue"]}
                placeholder={trans("Type value...")}
                onChange={(e) => {
                  store.dispatch({
                    type: "edit/config/update",
                    payload: {
                      property: "attributeValue",
                      value: e.target.value,
                    },
                  });
                }}
              ></input>
            </div>
            <div className="mt-2">
              <button
                className="btn btn-sm btn-secondary text-white small form-control"
                onClick={() => {
                  fetchSpatialResults(editConfig["layer"]);
                }}
              >
                <i className="fas fa-search me-2 small"></i>
                {trans("Search layer for features")}
              </button>
            </div>

            {editConfig["searchData"] ? (
              <>
                <div className="mt-2">
                  <PerfectScrollbar
                    style={{ maxHeight: "15rem" }}
                    className="pe-3"
                  >
                    <FeaturesTable
                      data={editConfig["searchData"]}
                      layerId={editConfig["layer"]}
                      attributes={layers[editConfig["layer"]]?.attributes}
                      selected={editConfig["selected"]?.map((el) => {
                        return el._featureId;
                      })}
                      onSelect={(feature) => {}}
                    ></FeaturesTable>
                  </PerfectScrollbar>
                </div>
                <div className="mt-2">
                  <span className="small">
                    {editConfig["selected"]?.length > 0
                      ? "".concat(editConfig["selected"].length, " ")
                      : trans("0 selected features")}
                  </span>
                </div>
              </>
            ) : null}
          </>
        );

        break;

      case "favorites":
        return (
          <>
            <div className="mt-2">
              <select
                className="form-select form-select-sm"
                key={key()}
                value={editConfig["layer"]}
                onChange={(e) => {
                  store.dispatch({
                    type: "edit/config/update",
                    payload: {
                      property: "layer",
                      value: e.target.value,
                    },
                  });
                  store.dispatch({
                    type: "edit/config/update",
                    payload: {
                      property: "searchData",
                      value: favorites[e.target.value],
                    },
                  });
                }}
              >
                <option value="">{trans("Select a layer")}</option>
                {Object.keys(favorites).map((favorite) => {
                  return (
                    <option value={favorite}>{layers[favorite]?.title}</option>
                  );
                })}
              </select>
            </div>
            {editConfig["searchData"] ? (
              <>
                <div className="mt-2">
                  <PerfectScrollbar
                    style={{ maxHeight: "15rem" }}
                    className="pe-3"
                  >
                    <FeaturesTable
                      data={editConfig["searchData"]}
                      attributes={layers[editConfig["layer"]]?.attributes}
                      onSelect={(feature) => {
                        updateSelectedFeatures(feature);
                      }}
                    ></FeaturesTable>
                  </PerfectScrollbar>
                </div>
                <div className="mt-2">
                  <span className="small">
                    {editConfig["selected"]?.length > 0
                      ? "".concat(
                          editConfig["selected"].length,
                          " ",
                          trans("selected features")
                        )
                      : trans("0 selected features")}
                  </span>
                </div>
              </>
            ) : null}
          </>
        );
        break;

      case "file":
        return (
          <>
            <div className="mt-2">
              <SelectFeaturesFromUploadFile
                selected={editConfig["selected"]?.map((el) => {
                  return el._featureId;
                })}
                onSelect={(feature) => {
                  updateSelectedFeatures(feature);
                }}
              ></SelectFeaturesFromUploadFile>
            </div>
          </>
        );
    }
  };

  function saveLayer() {
    let sourceURL = JSON.stringify({
      type: "FeatureCollection",
      features: [],
    });

    let layer = formatGEOJSONLayer({
      id: getLayerIdByName(newLayerName, sourceURL),
      name: newLayerName,
      title: newLayerName,
      projection: projection,
      geometryType: geometryType,
      geometryIsMulti: geometryMulti,
      attributes: newLayerAttributes.map((el) => {
        return {
          name: el.name,
          type: el.type,
          title: el.name,
          value: null,
          editor: el.type,
          sortable: true,
          order: 0,
          visible: true,
          searchable: true,
          isGeometry: false,
          isVisible: true,
          showOnSummary: false,
        };
      }),
      legend: window["appConfig"]()["api"](
        "?proxy=color&color=".concat(newLayerColor.hex.replace("#", ""))
      ),
      color: newLayerColor.hex.replace("#", ""),
      bbox: [],
      abstract: trans("Custom layer").concat(" ", newLayerName),
    });

    let source = {
      id: md5(sourceURL),
      type: "GEOJSON",
      name: "Custom",
      title: newLayerName,
      url: sourceURL,
    };

    layer.source = source;

    store.dispatch({
      type: "source/add",
      payload: { [source.id]: { ...source } },
    });

    addLayer(layer);

    store.dispatch({
      type: "layer/registeredlayertree/add",
      payload: layer,
    });

    store.dispatch({
      type: "edit/select/layer",
      payload: layer.id,
    });
  }

  function deleteAttribute(idx) {
    let attributes = [...newLayerAttributes];

    attributes.splice(idx, 1);

    setNewLayerAttributes(attributes);
  }

  function setAttribute(idx, property, value) {
    let attributes = [...newLayerAttributes];

    attributes[idx][property] = value;

    setNewLayerAttributes(attributes);
  }

  const isDark = (color) => {
    if (!color?.r) {
      return false;
    }
    return 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b <= 120;
  };

  function onLayerFeature(layer) {
    getLayerById(layer)
      .getSource()
      .on("addfeature", (e) => {
        if (!e.feature.getId()) {
          let _featureId = key();

          e.feature.setId(_featureId);
        }

        let geojson = FeatureToGeoJSON(e.feature);

        store.dispatch({
          type: "edit/addtohistory",
          payload: {
            featureId: e.feature.getId(),
            geojson: geojson,
            type: "add",
          },
        });
      });

    getLayerById(layer)
      .getSource()
      .on("removefeature", (e) => {
        let geojson = FeatureToGeoJSON(e.feature);

        store.dispatch({
          type: "edit/addtohistory",
          payload: {
            featureId: e.feature.getId(),
            geojson: geojson,
            type: "remove",
          },
        });
      });
  }

  function saveFeature() {
    let feature = getLayerById(selectedLayer)
      .getSource()
      .getFeatureById(selectedFeature._featureId);

    let properties = selectedFeature._feature.properties;

    if (properties) {
      Object.keys(properties).forEach((el) => {
        feature.set(el, properties[el]);
      });
    }

    store.dispatch({ type: "edit/save" });
  }

  return (
    <div className="ps-2 pe-2">
      <PerfectScrollbar style={{ height: "45px" }}>
        <ul className="nav nav-tabs navbar-expand small">
          <li className="nav-item " role="button">
            <span
              className="nav-link color-strong-grey nav-ellipsis active"
              data-bs-toggle="tab"
              data-bs-target={"#edit-tab-controls"}
            >
              <span className="color-black">
                <i className="fas fa-tools me-2"></i>
                {trans("Edit controls")}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className="nav-link color-strong-grey nav-ellipsis "
              data-bs-toggle="tab"
              data-bs-target={"#edit-tab-settings"}
            >
              <span className="color-black">
                <i className="fas fa-cog me-2"></i>
                {trans("Settings")}
              </span>
            </span>
          </li>
        </ul>
      </PerfectScrollbar>
      <div className="tab-content ">
        <div
          className="tab-pane fade  show active"
          role="tabpanel"
          id="edit-tab-controls"
        >
          <div className="m-3 ms-2">
            <div className="mt-2">
              <select
                className="form-select form-select-sm "
                value={selectedLayer}
                onChange={(e) => {
                  store.dispatch({
                    type: "edit/select/layer",
                    payload: e.target.value,
                  });
                }}
              >
                <option value="">{trans("Select a layer")}</option>
                {Object.keys(editableLayers)?.map((el) => {
                  let layer = editableLayers[el];

                  return <option value={layer.id}>{layer.title}</option>;
                })}
                <option value="new">{trans("+ Create custom layer")}</option>
              </select>
            </div>
            {selectedLayer === "new" ? (
              <>
                <div className="mt-3">
                  <label className="color-get-blue strong small ">
                    {trans("Layer name")}
                  </label>
                  <div className="mt-2 input-group">
                    <input
                      type="text"
                      className="form-control form-control-sm "
                      value={newLayerName}
                      placeholder="Set layer name"
                      onChange={(e) => {
                        setNewLayerName(e.target.value);
                      }}
                    ></input>
                  </div>
                </div>
                <div className="mt-2">
                  <label className="color-get-blue strong small">
                    {trans("Select projection system")}
                  </label>
                  <div className="mt-2 input-group">
                    <select
                      className="form-select form-select-sm"
                      value={projection}
                      onChange={(e) => {
                        setProjection(e.target.value);
                      }}
                    >
                      {window["appConfig"]()["projectionSystems"].map((opt) => {
                        return (
                          <option value={getProjectionCode(opt.code)}>
                            {opt.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="mt-2">
                  <label className="color-get-blue strong small">
                    {trans("Select geometry type")}
                  </label>
                  <div className="mt-2 input-group">
                    <select
                      className="form-select form-select-sm"
                      value={geometryType}
                      onChange={(e) => {
                        setGeometryType(e.target.value);
                      }}
                    >
                      <option value="polygon">{trans("Polygon")}</option>
                      <option value="line">{trans("Line")}</option>
                      <option value="point">{trans("Point")}</option>
                    </select>
                  </div>
                </div>
                <div className="mt-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckMutli"
                      checked={geometryMulti}
                      onChange={(e) => {
                        setGeometryMulti(e.target.checked);
                      }}
                    />
                    <label
                      className="form-check-label color-get-blue strong small"
                      for="flexCheckMutli"
                    >
                      {trans("Geometry is multi")}
                    </label>
                  </div>
                </div>
                <div className="mt-2">
                  <div>
                    <div
                      style={styles.swatch}
                      onClick={() => {
                        setDisplayColorPicker(
                          displayColorPicker ? false : true
                        );
                      }}
                    >
                      <div
                        className={"form-control text-center ".concat(
                          isDark(newLayerColor?.rgb) ? "text-white" : ""
                        )}
                        style={{
                          borderRadius: "2px",
                          width: "100%",
                          background: `rgba(${newLayerColor?.rgb?.r}, ${newLayerColor?.rgb?.g}, ${newLayerColor?.rgb?.b}, ${newLayerColor?.rgb?.a})`,
                        }}
                      >
                        {newLayerColor.hex
                          ? newLayerColor?.hex
                          : trans("Select fill color")}
                      </div>
                    </div>
                    {displayColorPicker ? (
                      <div style={styles.popover}>
                        <div
                          style={styles.cover}
                          onClick={() => {
                            setDisplayColorPicker(false);
                          }}
                        />

                        <SketchPicker
                          color={newLayerColor}
                          onChange={(color) => {
                            setNewLayerColor({
                              rgb: color.rgb,
                              hex: color.hex,
                            });
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mt-3">
                  <label className="color-get-blue strong small">
                    {trans("Attributes")}
                  </label>
                  <div className="mt-2">
                    {newLayerAttributes.map((el, idx) => {
                      return (
                        <div className="mt-2 d-flex">
                          <input
                            type="text"
                            value={el.name}
                            placeholder={trans("Set attribute name")}
                            className="form-control form-control-sm "
                            onChange={(e) => {
                              setAttribute(idx, "name", e.target.value);
                            }}
                          ></input>
                          <select
                            className="form-select form-select-sm ms-2"
                            value={el.type}
                            onChange={(e) => {
                              setAttribute(idx, "type", e.target.value);
                            }}
                          >
                            {window["appConfig"]()
                              ["editors"]()
                              .map((opt) => {
                                return <option value={opt}>{opt}</option>;
                              })}
                          </select>
                          <button
                            className="btn btn-sm"
                            onClick={() => {
                              deleteAttribute(idx);
                            }}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                  <div className="mt-2 ">
                    <span
                      className="small"
                      role="button"
                      onClick={() => {
                        setNewLayerAttributes([...newLayerAttributes, {}]);
                      }}
                    >
                      <i className="fas fa-plus me-2"></i>
                      {trans("Add new attribute")}
                    </span>
                  </div>
                </div>
                <div className="mt-2 text-end">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary me-2 text-white"
                    onClick={() => {
                      setNewLayerName("");
                      setNewLayerColor({
                        hex: "",
                        rgb: { r: "255", b: "255", g: "255", a: 1 },
                      });
                      setNewLayerAttributes([]);
                    }}
                  >
                    {trans("Clear")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary text-white"
                    onClick={() => {
                      saveLayer();
                    }}
                  >
                    {trans("Save layer")}
                  </button>
                </div>
              </>
            ) : selectedLayer ? (
              <>
                <div className="mt-3">
                  <select
                    className="form-select form-select-sm "
                    value={editConfig.spatialType}
                    onChange={(e) => {
                      removeInteraction("select");

                      store.dispatch({
                        type: "edit/config/update",
                        payload: {
                          property: "spatialType",
                          value: e.target.value,
                        },
                      });
                    }}
                  >
                    <option value="draw">{trans("Draw features")}</option>
                    <option value="modify">{trans("Modify features")}</option>
                  </select>
                  {editSpatialContent()}
                </div>
                {selectedContent()}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="tab-pane fade " role="tabpanel" id="edit-tab-settings">
          <PerfectScrollbar className="scrollbar-recaclulate">
            <BootstrapTable
              key={key()}
              keyField="id"
              data={Object.keys(editableLayers).map((el) => {
                return editableLayers[el];
              })}
              columns={[
                {
                  dataField: "title",
                  text: trans("Title"),
                  headerStyle: (colum, colIndex) => {
                    return { width: "100%" };
                  },
                },
                {
                  dataField: "_canCopy",
                  text: trans("Can copy"),
                  headerStyle: (colum, colIndex) => {
                    return { width: "30px", textAlign: "center" };
                  },
                },
                {
                  dataField: "_canSnap",
                  text: trans("Can snap"),
                  headerStyle: (colum, colIndex) => {
                    return { width: "30px", textAlign: "center" };
                  },

                  formatter: function (cell, row) {
                    return (
                      <div className="w-100 text-center ">
                        <input
                          type="checkbox"
                          className="form-checkbox m-auto"
                          checked={row.editCanTrace ? true : false}
                          onChange={(e) => {
                            store.dispatch({
                              type: "layer/update",
                              payload: {
                                id: row.id,
                                property: "editCanTrace",
                                value: e.target.checked,
                              },
                            });
                            window["map"].removeInteraction(window["editDraw"]);
                          }}
                        ></input>
                      </div>
                    );
                  },
                },
                {
                  dataField: "_canSnapEdge",
                  text: trans("Can snap edge"),
                  headerStyle: (colum, colIndex) => {
                    return { width: "30px", textAlign: "center" };
                  },
                  formatter: function (cell, row) {
                    return (
                      <div className="w-100 text-center ">
                        <input
                          type="checkbox"
                          className="form-checkbox m-auto"
                          checked={row.editCanSnapEdge ? true : false}
                          onChange={(e) => {
                            store.dispatch({
                              type: "layer/update",
                              payload: {
                                id: row.id,
                                property: "editCanSnapEdge",
                                value: e.target.checked,
                              },
                            });
                            window["map"].removeInteraction(window["editDraw"]);
                          }}
                        ></input>
                      </div>
                    );
                  },
                },
                {
                  dataField: "_canSnapNode",
                  text: trans("Can snap nodes"),
                  headerStyle: (colum, colIndex) => {
                    return { width: "30px", textAlign: "center" };
                  },
                  formatter: function (cell, row) {
                    return (
                      <div className="w-100 text-center ">
                        <input
                          type="checkbox"
                          className="form-checkbox m-auto"
                          checked={row.editCanSnapVertex ? true : false}
                          onChange={(e) => {
                            store.dispatch({
                              type: "layer/update",
                              payload: {
                                id: row.id,
                                property: "editCanSnapVertex",
                                value: e.target.checked,
                              },
                            });
                            window["map"].removeInteraction(window["editDraw"]);
                          }}
                        ></input>
                      </div>
                    );
                  },
                },
              ]}
              wrapperClasses="bg-white"
              striped
              hover
            />
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
}

export default EditPanel;
